import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function WorkshopProblem() {
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-2243">
      <div className="max-w-4xl mx-auto px-6" data-id="element-2244">
        <SectionHeading title="Ce se întâmplă când amâni schimbarea pe care o simți că trebuie să o faci?" data-id="element-2245" />

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-brand-cream rounded-3xl p-8 md:p-12 shadow-sm border border-brand-text/5 mb-12" data-id="element-2246">
          <div className="space-y-6 text-lg text-brand-text/80 leading-relaxed" data-id="element-2247">
            <p className="font-bold text-xl text-brand-text" data-id="element-2248">
              Te trezești dimineața cu același sentiment de neajuns. Muncești,
              te descurci, funcționezi. Dar în interior simți un gol pe care nu
              ți-l poți explica.
            </p>
            <p data-id="element-2249">
              Ai o relație complicată cu banii. Oricât ai câștiga, parcă nu e
              suficient. Și nu înțelegi de ce abundența pare să vină greu spre
              tine. Ai citit cărți, ai meditat, ai fost la cursuri. Dar fără
              ghidare constantă și fără practică reală, totul a rămas la nivel
              de teorie. Și viața ta continuă cu aceleași tipare.
            </p>
            <p data-id="element-2250">
              Îți spui că într-o zi vei face o schimbare. Dar ziua aia nu vine
              niciodată de la sine. Te costă. Stres, relații tensionate,
              stagnare financiară și sentimentul că îți irosești viața. Cel mai
              mare preț nu e financiar. E liniștea, bucuria și viața trăită cu
              adevărat pe care o pierzi cu fiecare zi în care nu faci nimic
              diferit.
            </p>

            <div className="mt-8 p-6 bg-brand-gold/5 border-l-4 border-brand-gold rounded-r-xl" data-id="element-2251">
              <p className="font-medium text-brand-text italic" data-id="element-2252">
                Am întâlnit sute de oameni care se simțeau exact așa. În peste
                25 de ani de lucru cu terapii complementare și dezvoltare
                personală, am văzut același tipar repetându-se. De aceea am
                creat acest workshop gratuit, în care îți arăt concret ce te
                blochează și ce poți face începând de azi.
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-2253">
          <CTAButton data-id="element-2254" />
        </motion.div>
      </div>
    </section>;
}